"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OidcSecure = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const authentication_service_1 = require("../authentication-service");
const oidc_service_1 = require("../oidc-service");
const authenticating_1 = require("./authenticating");
const authentication_provider_1 = require("./authentication-provider");
/**
 * Component redirecting to login screen if no user found or the access token expired
 */
const OidcSecure = ({ children, history }) => {
    const context = react_1.useContext(authentication_provider_1.AuthenticationContext);
    if (!context) {
        throw new Error('useOidcAuthentication must be used within a AuthenticationProvider');
    }
    const { oidcUser, authenticating } = context;
    react_1.useEffect(() => {
        oidc_service_1.authenticateUser(authentication_service_1.getUserManager(), history.location, history)();
    }, [history]);
    const requiredAuth = !oidcUser || (oidcUser === null || oidcUser === void 0 ? void 0 : oidcUser.expired) === true;
    const authenticatingComponent = authenticating || react_1.default.createElement(authenticating_1.Authenticating, null);
    return requiredAuth ? react_1.default.createElement(react_1.default.Fragment, null, authenticatingComponent) : react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.OidcSecure = OidcSecure;
//# sourceMappingURL=oidc-secure.js.map